<template>
  <!-- 요약 카드: 기간 내 총 발행수 + 오늘 발행수 (REQ-MOD-2 U-2.4)
       ranking-grid와 동일한 gap 기반 그리드 수식(calc(50% - 8px) + gap:16px)을 사용해
       카드 좌우 경계가 다른 위젯 행과 정확히 일치하도록 한다. -->
  <div class="summary-cards">
    <div class="summary-card">
      <div class="summary-card-icon" style="background-color: #d6ebff">
        <i class="fa-solid fa-file-certificate" style="color: #519eec" />
      </div>
      <div class="summary-card-body">
        <span class="summary-card-label">{{ $t('dashboard_total_nfts') }}</span>
        <h5 v-if="!loading && !error" class="summary-card-value">
          {{ formatCommaNumber(totalCount) }}<span>{{ $t('common_case') }}</span>
        </h5>
        <a-spin v-else-if="loading" size="small" />
        <span v-else class="summary-error">{{ $t('dashboard_widget_load_err_short') }}</span>
      </div>
    </div>
    <div class="summary-card">
      <div class="summary-card-icon" style="background-color: #d6ddff">
        <i class="fa-regular fa-calendar-days" style="color: #788ced" />
      </div>
      <div class="summary-card-body">
        <span class="summary-card-label">{{ $t('dashboard_nfts_today') }}</span>
        <h5 v-if="!loading && !error" class="summary-card-value">
          {{ formatCommaNumber(todayCount) }}<span>{{ $t('common_case') }}</span>
        </h5>
        <a-spin v-else-if="loading" size="small" />
        <span v-else class="summary-error">{{ $t('dashboard_widget_load_err_short') }}</span>
      </div>
    </div>
    <a-button v-if="error" size="small" class="summary-retry" @click="$emit('retry')">
      {{ $t('dashboard_widget_retry') }}
    </a-button>
  </div>
</template>

<script>
import { formatCommaNumber } from '@/utils/utils';

export default {
  name: 'SummaryCards',
  emits: ['retry'],
  props: {
    totalCount: { type: Number, default: 0 },
    todayCount: { type: Number, default: 0 },
    loading: { type: Boolean, default: false },
    error: { type: Boolean, default: false },
  },
  data() {
    return {
      formatCommaNumber,
    };
  },
};
</script>

<style scoped>
.summary-cards {
  display: flex;
  gap: 16px;
  width: 100%;
}

/* flex-grow/basis 대신 명시적 width 사용(다른 위젯 행과 픽셀 단위로 폭을 맞추기 위함) */
.summary-card {
  width: calc(50% - 8px);
  flex: none;
  min-width: 0;
  box-sizing: border-box;
  background: #fff;
  border-radius: 16px;
  padding: 24px 20px;
  display: flex;
  align-items: center;
}

.summary-card-icon {
  width: 40px;
  height: 40px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 16px;
  flex-shrink: 0;
}

.summary-card-icon i {
  font-size: 18px;
}

.summary-card-body {
  min-width: 0;
}

.summary-card-label {
  font-size: 14px;
  color: #8d939a;
}

.summary-card-value {
  font-size: 24px;
  font-weight: bold;
  color: #4b5158;
  margin-bottom: 0;
}

.summary-card-value span {
  font-size: 14px;
  font-weight: normal;
  margin-left: 3px;
}

.summary-error {
  font-size: 14px;
  color: #f5a623;
}

.summary-retry {
  margin-top: -8px;
  margin-bottom: 16px;
}
</style>
